module.exports = __webpack_public_path__ + "static/img/欢乐岛mob@2x .e1d4aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/mob/欢乐岛mob@2x .png
// module id = mStY
// module chunks = 1